import React from 'react';

const SkeletonCard = () => {
  return (
    <div className="card h-full flex flex-col animate-pulse">
      <div className="p-4 flex-1 flex flex-col">
        {/* Badge skeleton */}
        <div className="mb-2">
          <div className="h-6 w-20 bg-slate-200 rounded-full" />
        </div>
        
        {/* Title skeleton */}
        <div className="mb-2">
          <div className="h-5 bg-slate-200 rounded w-3/4 mb-2" />
          <div className="h-5 bg-slate-200 rounded w-1/2" />
        </div>
        
        {/* Date skeleton */}
        <div className="mb-3">
          <div className="h-4 bg-slate-200 rounded w-full" />
        </div>
        
        {/* Artists skeleton */}
        <div className="mb-2">
          <div className="h-4 bg-slate-200 rounded w-2/3" />
        </div>
        
        {/* Venue skeleton */}
        <div className="mt-auto">
          <div className="h-4 bg-slate-200 rounded w-1/2" />
        </div>
      </div>
    </div>
  );
};

const SkeletonGrid = ({ count = 6 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  );
};

export { SkeletonCard, SkeletonGrid };
export default SkeletonCard;
